import { format, parseISO } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';
import { sv } from 'date-fns/locale';

const STOCKHOLM_TZ = 'Europe/Stockholm';

export function formatPrice(priceOreKwh: number): string {
  return priceOreKwh.toFixed(2);
}

export function formatTime(isoString: string): string {
  return format(parseISO(isoString), 'HH:mm');
}

export function formatTimeRange(start: string, end: string): string {
  return `${formatTime(start)} - ${formatTime(end)}`;
}

export function formatDate(date: string | Date): string {
  const d = typeof date === 'string' ? parseISO(date) : date;
  return format(d, 'yyyy-MM-dd');
}

export function formatDateDisplay(date: string | Date): string {
  const d = typeof date === 'string' ? parseISO(date) : date;
  return format(d, 'd MMMM yyyy', { locale: sv });
}

export function isCurrentPeriod(start: string, end: string): boolean {
  // Convert all times to Stockholm timezone for comparison
  const now = toZonedTime(new Date(), STOCKHOLM_TZ);
  const startDate = toZonedTime(parseISO(start), STOCKHOLM_TZ);
  const endDate = toZonedTime(parseISO(end), STOCKHOLM_TZ);
  return now >= startDate && now < endDate;
}

export function getChartTime(isoString: string): string {
  // Return just the hour:minute for x-axis labels
  return format(parseISO(isoString), 'HH:mm');
}
